import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from 'src/app/services/inventory-service';

@Component({
  selector: 'app-entry-sap-report',
  templateUrl: './entry-sap-report.component.html',
  styleUrls: ['./entry-sap-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class EntrySapReportComponent implements OnInit {

  loading:boolean = false;

  date1:Date = new Date();
  date2:Date = new Date();

  lineTotal:number = 0;

  data = [];

  constructor(private entryServ:InventoryService) { }

  ngOnInit() {
    this.search();
  }

  search(){
    this.loading = true;
    this.lineTotal = 0;
    this.entryServ.getReport(this.date1, this.date2, null, null, true).then(resp=>{
      this.data = resp;
      this.lineTotal = this.data.map(da=> Number(da.LineTotal)).reduce((an, ac)=> ac + an, 0);
      this.loading = false;
    });
  }

}
